import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './status-badge.module.scss';

export type StatusBadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';
type StatusBadgeSize = 'regular' | 'small';

interface IStatusBadgeProps {
  variant: StatusBadgeVariant;
  /** `small` is the dense 11px style for space-constrained rows. */
  size?: StatusBadgeSize;
  children: ReactNode;
  className?: string;
}

const StatusBadge: FC<IStatusBadgeProps> = ({
  variant,
  size = 'regular',
  children,
  className,
}) => (
  <span className={classNames(styles.badge, styles[size], styles[variant], className)}>
    {children}
  </span>
);

export { StatusBadge };
